module.exports = __webpack_public_path__ + "static/media/icons.b87b9ba5.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/semantic/themes/default/assets/fonts/icons.ttf
// module id = 4406
// module chunks = 0